module.exports = __webpack_public_path__ + "static/media/wikipedia-logo.f5da73be.png";